var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323237",
    fillRule: "evenodd",
    d: "M6.667 7.714L0 1.286 1.333 0 8 6.428 14.667 0 16 1.286 9.332 7.713l.001.001L8 9 6.667 7.714z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormDropdownArrow);
export default __webpack_public_path__ + "static/media/form-dropdown-arrow.0a1f6446b3a090e3085561158e6b2fb6.svg";
export { ForwardRef as ReactComponent };